module.exports = __webpack_public_path__ + "img/1.b1ab02ba.png";